import { fetchEligibility } from "../clients/eligibilityClient";
import { Eligibility } from "../../models/Eligibility";

export const getEligibility = async (user_id) => {
  const data = await fetchEligibility(user_id);
  return Eligibility.fromJson(data);
};
